/**
 * Type of block
 */
export enum BlockType {
  PrimaryCollection = "PrimaryCollection",
  Primary = "Primary",
  Header = "Header",
  Footer = "Footer",
  FooterWidget = "FooterWidget",
  Secondary = "Secondary",
  Tertiary = "Tertiary",
}
